import { type Enum } from '@webapp/utils'

export const UnbilledItemStatuses = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
} as const

export type UnbilledItemStatus = Enum<typeof UnbilledItemStatuses>
